// Generated by purs version 0.13.0
"use strict";
var Chip_Model_Direction = require("../Chip.Model.Direction/index.js");
var toRight = function (v) {
    if (v instanceof Chip_Model_Direction.Up) {
        return Chip_Model_Direction.Right.value;
    };
    if (v instanceof Chip_Model_Direction.Right) {
        return Chip_Model_Direction.Down.value;
    };
    if (v instanceof Chip_Model_Direction.Down) {
        return Chip_Model_Direction.Left.value;
    };
    if (v instanceof Chip_Model_Direction.Left) {
        return Chip_Model_Direction.Up.value;
    };
    throw new Error("Failed pattern match at Chip.Mutation.Direction (line 17, column 11 - line 21, column 13): " + [ v.constructor.name ]);
};
var toLeft = function (v) {
    if (v instanceof Chip_Model_Direction.Up) {
        return Chip_Model_Direction.Left.value;
    };
    if (v instanceof Chip_Model_Direction.Left) {
        return Chip_Model_Direction.Down.value;
    };
    if (v instanceof Chip_Model_Direction.Down) {
        return Chip_Model_Direction.Right.value;
    };
    if (v instanceof Chip_Model_Direction.Right) {
        return Chip_Model_Direction.Up.value;
    };
    throw new Error("Failed pattern match at Chip.Mutation.Direction (line 10, column 10 - line 14, column 14): " + [ v.constructor.name ]);
};
var invert = function (v) {
    if (v instanceof Chip_Model_Direction.Up) {
        return Chip_Model_Direction.Down.value;
    };
    if (v instanceof Chip_Model_Direction.Down) {
        return Chip_Model_Direction.Up.value;
    };
    if (v instanceof Chip_Model_Direction.Right) {
        return Chip_Model_Direction.Left.value;
    };
    if (v instanceof Chip_Model_Direction.Left) {
        return Chip_Model_Direction.Right.value;
    };
    throw new Error("Failed pattern match at Chip.Mutation.Direction (line 24, column 10 - line 28, column 16): " + [ v.constructor.name ]);
};
module.exports = {
    invert: invert,
    toLeft: toLeft,
    toRight: toRight
};
